/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import SVG from "react-inlinesvg";
import { checkIsActive, toAbsoluteUrl } from "_metronic/_helpers";
import { useSelector } from "react-redux";
import { map, size } from "lodash";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"
      } menu-item-open menu-item-not-hightlighted`
      : "";
  };
  const listMenu = useSelector(state => state.app.listMenu);

  const renderMenuItem = (menu, isParent = false) => {
    const isMenuHasChild = size(menu.children) > 0;
    let liClassName = `menu-item ${isParent ? "menu-item-parent" : ""}`;
    let navLinkClassName = `menu-link`;
    if (isMenuHasChild) {
      liClassName += " menu-item-submenu";
      navLinkClassName += " menu-toggle";
    }
    liClassName += ` ${getMenuItemActive(menu.path, isMenuHasChild)}`;

    return (
      <li
        key={menu.id}
        className={liClassName}
        aria-haspopup="true"
        data-menu-toggle={isMenuHasChild ? "hover" : "none"}
      >
        <NavLink className={navLinkClassName} to={menu.path}>
          <span className="svg-icon menu-icon">
            {menu.icon && <SVG src={toAbsoluteUrl(menu.icon)} />}
          </span>
          <span className="menu-text">{menu.name}</span>
          {isMenuHasChild && <i className="menu-arrow" />}
        </NavLink>
        {isMenuHasChild && (
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              {map(menu.children, childMenu => renderMenuItem(childMenu))}
            </ul>
          </div>
        )}
      </li>
    );
  };

  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {map(listMenu, menu => renderMenuItem(menu))}
      </ul>
    </>
  );
}
